var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "请购单号",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入请购单号查询",
                                    },
                                    model: {
                                      value: _vm.queryParam.billNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "billNo", $$v)
                                      },
                                      expression: "queryParam.billNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 12, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "section",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: false,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "expandedRowRender",
                        fn: function (record) {
                          return _vm._l(record.items, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.itemId,
                                staticClass: "pending-item-row",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.materialName) +
                                    " × " +
                                    _vm._s(item.operNumber) +
                                    _vm._s(item.materialUnit || "") +
                                    "\n              "
                                ),
                                item.defaultSupplierName
                                  ? _c(
                                      "span",
                                      { staticClass: "default-supplier-tip" },
                                      [
                                        _vm._v(
                                          "（默认归属：" +
                                            _vm._s(item.defaultSupplierName) +
                                            "）"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          })
                        },
                      },
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c(
                            "span",
                            {},
                            [
                              _vm.btnEnableList.indexOf(1) > -1
                                ? [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAssign(record)
                                          },
                                        },
                                      },
                                      [_vm._v("分配")]
                                    ),
                                    _c("a-divider", {
                                      attrs: { type: "vertical" },
                                    }),
                                    _c(
                                      "a-popconfirm",
                                      {
                                        attrs: {
                                          title:
                                            "确认整单标记自采？将不生成采购订单。",
                                        },
                                        on: {
                                          confirm: function ($event) {
                                            return _vm.handleSelfPick(record)
                                          },
                                        },
                                      },
                                      [_c("a", [_vm._v("标记自采")])]
                                    ),
                                  ]
                                : _c("span", [_vm._v("-")]),
                            ],
                            2
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("a-pagination", {
                staticStyle: { "margin-top": "16px", "text-align": "right" },
                attrs: {
                  current: _vm.ipagination.current,
                  pageSize: _vm.ipagination.pageSize,
                  total: _vm.ipagination.total,
                },
                on: {
                  change: _vm.paginationChange,
                  showSizeChange: _vm.paginationShowSizeChange,
                },
              }),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: _vm.assignTitle,
                    visible: _vm.assignVisible,
                    confirmLoading: _vm.assignLoading,
                    maskClosable: false,
                    width: "760px",
                  },
                  on: {
                    ok: _vm.handleAssignOk,
                    cancel: function ($event) {
                      _vm.assignVisible = false
                    },
                  },
                },
                [
                  _c("a-table", {
                    attrs: {
                      size: "small",
                      bordered: "",
                      rowKey: "itemId",
                      columns: _vm.assignColumns,
                      dataSource: _vm.assignItems,
                      pagination: false,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "supplierSelect",
                        fn: function (text, item) {
                          return [
                            _c(
                              "a-select",
                              {
                                staticStyle: { width: "260px" },
                                attrs: {
                                  showSearch: "",
                                  optionFilterProp: "children",
                                  placeholder: "请选择供应商",
                                },
                                model: {
                                  value: item.supplierId,
                                  callback: function ($$v) {
                                    _vm.$set(item, "supplierId", $$v)
                                  },
                                  expression: "item.supplierId",
                                },
                              },
                              _vm._l(
                                _vm.itemOptions(item),
                                function (supplier) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: supplier.id,
                                      attrs: { value: supplier.id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(supplier.supplierName) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "12px" } },
                    [
                      _c(
                        "a-checkbox",
                        {
                          model: {
                            value: _vm.assignSetDefault,
                            callback: function ($$v) {
                              _vm.assignSetDefault = $$v
                            },
                            expression: "assignSetDefault",
                          },
                        },
                        [
                          _vm._v(
                            "设为默认归属（同类请购单后续自动拆分到该供应商）"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }